import { render, staticRenderFns } from "./Fullname.vue?vue&type=template&id=5e3f37ca&scoped=true&"
import script from "./Fullname.vue?vue&type=script&lang=js&"
export * from "./Fullname.vue?vue&type=script&lang=js&"
import style0 from "./Fullname.vue?vue&type=style&index=0&id=5e3f37ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3f37ca",
  null
  
)

export default component.exports